module.exports = __webpack_public_path__ + "media/images/emblems/Rueschlikon-blazon-177573858a36e7ae5e2b49e6d0b30d43.svg";